(() => {
  'use strict';
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f\s\u2013-]/g, '').toLowerCase();
  const init = () => {
    document.querySelectorAll('[data-sl-discovery]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const cards = [...root.querySelectorAll('[data-sl-card]')];
      const buttons = [...root.querySelectorAll('[data-sl-filter]')];
      const search = root.querySelector('[data-sl-search]');
      const stock = root.querySelector('[data-sl-stock]');
      const status = root.querySelector('[data-sl-count]');
      const empty = root.querySelector('[data-sl-empty]');
      let selected = 'all';
      const queryKey = root.dataset.queryKey;
      const initial = queryKey && new URL(window.location.href).searchParams.get(queryKey);
      if (buttons.some(button => button.dataset.slFilter === initial)) selected = initial;
      const update = () => {
        const query = normalize(search?.value || '');
        let count = 0;
        cards.forEach(card => {
          const groups = (card.dataset.groups || '').split(' ');
          const show = (selected === 'all' || groups.includes(selected)) && normalize(card.dataset.search || card.textContent).includes(query) && (!stock?.checked || card.dataset.available === 'true');
          card.hidden = !show;
          if (show) count++;
        });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.slFilter === selected)));
        if (status) status.textContent = `${count} ${status.dataset.label}`;
        if (empty) empty.hidden = count !== 0;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        selected = button.dataset.slFilter;
        if (queryKey) {
          const url = new URL(window.location.href);
          if (selected === 'all') url.searchParams.delete(queryKey); else url.searchParams.set(queryKey, selected);
          window.history.replaceState(null, '', url);
        }
        update();
      }));
      root.querySelectorAll('[data-sl-reset]').forEach(button => button.addEventListener('click', () => {
        selected = 'all';
        if (search) search.value = '';
        if (stock) stock.checked = false;
        if (queryKey) { const url = new URL(window.location.href); url.searchParams.delete(queryKey); window.history.replaceState(null, '', url); }
        update();
        search?.focus();
      }));
      search?.addEventListener('input', update);
      stock?.addEventListener('change', update);
      root.querySelectorAll('[data-sl-enhance]').forEach(element => { element.hidden = false; });
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  // Use the existing Shopify pixel system; omit query strings and form contents.
  if (window.Shopify?.loadFeatures && !window.Shopify.customerPrivacy) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  const publish = (name, details) => {
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true || !window.Shopify?.analytics?.publish) return;
      Promise.resolve(window.Shopify.analytics.publish(`snake_lake:${name}`, details)).catch(() => {});
    } catch (_) { /* Analytics must never interrupt shopping. */ }
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.href);
    let kind = link.dataset.slTrack;
    if (!kind && url.hostname === 'breww.com') kind = 'wholesale_click';
    if (!kind && (url.hostname === 'maps.google.com' || url.hostname === 'www.google.com') && url.pathname.includes('/maps')) kind = 'directions_click';
    if (!kind && url.origin === window.location.origin && url.pathname.startsWith('/products/')) kind = 'product_click';
    if (kind) publish(kind, { target_path: url.pathname, source_path: window.location.pathname });
  });
  document.querySelectorAll('form[data-sl-contact]').forEach(form => {
    if (form.querySelector('[data-sl-inquiry-success]')) publish('inquiry_sent', { source_path: window.location.pathname });
  });
})();
